import {
  ByIdPayload,
  ChangeParamsByIdPayload,
  FailByIdPayload,
  ListReducerTypes,
  NormalizedList,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { PartListParams } from '../models/part-list-params';

export const PartLoadListActionTypes: ListReducerTypes = {
  request: uniqueActionType('[part] Load list'),
  requestFail: uniqueActionType('[part] Load list fail'),
  requestSuccess: uniqueActionType('[part] Load list success'),
  requestClear: uniqueActionType('[part] Load list clear'),
  changeParams: uniqueActionType('[part] Load list change params'),
  clearParams: uniqueActionType('[part] Load list clear params'),
  clearIds: uniqueActionType('[part] Load list clear ids')
};

export class PartLoadListAction implements PayloadAction {
  readonly type = PartLoadListActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class PartLoadListFailAction implements PayloadAction {
  readonly type = PartLoadListActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class PartLoadListSuccessAction implements PayloadAction {
  readonly type = PartLoadListActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedList>) {
  }
}

export class PartLoadListClearAction implements PayloadAction {
  readonly type = PartLoadListActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class PartLoadListChangeParamsAction implements PayloadAction {
  readonly type = PartLoadListActionTypes.changeParams;

  constructor(public payload: ChangeParamsByIdPayload<PartListParams>) {
  }
}

export class PartLoadListClearParamsAction implements PayloadAction {
  readonly type = PartLoadListActionTypes.clearParams;

  constructor(public payload: ByIdPayload) {
  }
}


export class PartLoadListClearIdsAction implements PayloadAction {
  readonly type = PartLoadListActionTypes.clearIds;

  constructor(public payload: ByIdPayload) {
  }
}
